var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-dark text-uppercase",class:{
    'active': _vm.checked,
  },attrs:{"type":"button","id":"btn-all-versions"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{class:{
      'far': !_vm.checked,
      'fas': _vm.checked,
      'fa-circle': !_vm.checked,
      'fa-check-circle': _vm.checked,
    }}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }